import { Box } from '@mui/material';
import { getAddAutomationButtonByType, getTypeNameFromVariant } from './helper';
import EmptyStateWithButton from '../common/empty-state/EmptyStateWithButton';
import { ReactNode } from 'react';
import EmptyState from '../common/empty-state/EmptyState';
import { useAutomationsContext } from './AutomationsContext';
import { DedupMatchingType } from '../../types/enums/DedupMatchingType';
import { CrmOrgPermissionQuery } from '../../permissions/permissions.types';

interface EmptyStateProps {
  onSelect: (object: string, type?: DedupMatchingType) => void;
  disabled: boolean;
  crmOrgId: string;
  subtitle?: string;
  title: string;
  defaultObjectType?: string;
  image: ReactNode;
}

export const AutomationsEmptyState = ({
  onSelect,
  disabled,
  crmOrgId,
  subtitle,
  title,
  defaultObjectType,
  image,
}: EmptyStateProps) => {
  const { permissions, automationVariant } = useAutomationsContext();
  const permissionQuery: CrmOrgPermissionQuery[] = [{ permission: permissions.create, crmOrgId }];
  return (
    <Box
      sx={{
        textAlign: 'center',
        ml: 'auto',
        mr: 'auto',
        p: '160px 16px',
      }}
    >
      {defaultObjectType && (
        <EmptyStateWithButton
          image={image}
          line1={subtitle}
          titleLine={title}
          onClick={() => {
            onSelect(defaultObjectType);
          }}
          buttonDisabled={disabled}
          permissionQuery={permissionQuery}
          notAllowedTitle={`To create a new ${getTypeNameFromVariant(
            automationVariant,
          )}, please contact your admin.`}
          buttonSize="small"
        />
      )}
      {!defaultObjectType && (
        <EmptyState image={image} line1={subtitle} titleLine={title}>
          {getAddAutomationButtonByType({
            variant: automationVariant,
            props: {
              disabled,
              onSelect,
              crmOrgId,
              buttonText: 'Get started',
              automationVariant,
              isEmptyState: true,
            },
          })}
        </EmptyState>
      )}
    </Box>
  );
};
